import Fetch from '../utils/fetch';
import { settings } from '../settings';
import {
  StoreSettings,
  ValueBasedDiscount,
} from '../pages/users/storeSettings/storeTypes';
import { ERROR } from '../const/error';

export const fetchAllStoresInfo = async (): Promise<StoreSettings[]> => {
  try {
    const url = `${settings.newApiUrl}/store/settings/internal`;
    const response = await Fetch.get({ url });

    if (response.ok) return response.json();
    return [];
  } catch (e) {
    console.log(ERROR.FETCH_CAPACITY_INFO, e);
    return [];
  }
};

export const fetchStoreInfo = async (
  accountId: string
): Promise<StoreSettings | undefined> => {
  try {
    const url = `${settings.newApiUrl}/store/settings/internal?accountId=${accountId}`;
    const response = await Fetch.get({ url });

    if (response.ok) {
      const responseBody = await response.json();
      const temperatureControlPriceAdjustment: string = (
        responseBody.temperatureControlPriceAdjustment / 100
      ).toString();
      const discountThresholds: ValueBasedDiscount[] =
        responseBody.discountThresholds
          .sort((first, second) => first.threshold - second.threshold)
          .map(({ threshold, discount }) => {
            return {
              threshold: (threshold / 100).toString(),
              discount: (discount / 100).toString(),
            };
          });
      const displayBasePriceCents =
        responseBody.displayBasePrice &&
        (responseBody.displayBasePrice.fractionalDenomination / 100).toString();

      return {
        ...responseBody,
        displayBasePriceCents,
        temperatureControlPriceAdjustment,
        discountThresholds,
      };
    } else {
      return undefined;
    }
  } catch (e) {
    console.log(ERROR.FETCH_CAPACITY_INFO, e);
    return undefined;
  }
};

interface ResultSuccess {
  type: 'success';
}

interface ResultFailure {
  type: 'failure';
  errorMessage: string;
}

type Result = ResultSuccess | ResultFailure;

export const saveStoreSettings = async (
  storeSettings: StoreSettings
): Promise<Result> => {
  try {
    const formatNumber = (val: string) =>
      Number(val.replaceAll(',', '.')) * 100;
    const displayBasePriceCents =
      storeSettings.displayBasePriceCents &&
      formatNumber(storeSettings.displayBasePriceCents);
    const temperatureControlPriceAdjustment = formatNumber(
      storeSettings.temperatureControlPriceAdjustment
    );
    const discountThresholds = storeSettings.discountThresholds
      .map(({ threshold, discount }) => {
        return {
          threshold: formatNumber(threshold),
          discount: formatNumber(discount),
        };
      })
      .sort((first, second) => first.threshold - second.threshold);

    const result = await Fetch.put({
      url: `${settings.newApiUrl}/store/settings/internal`,
      body: {
        ...storeSettings,
        displayBasePriceCents,
        temperatureControlPriceAdjustment,
        discountThresholds,
      },
    });
    if (result.ok) {
      return { type: 'success' };
    } else {
      return {
        type: 'failure',
        errorMessage: ERROR.COULDNT_UPDATE_STORE_SETTINGS,
      };
    }
  } catch (e) {
    console.log(ERROR.UPDATE_STORE_SETTINGS, e);
    return { type: 'failure', errorMessage: ERROR.SOMETHING_WRONG };
  }
};
